export const COUNT_MAX = 20;
export const ICON_URL_FALLBACK =
    'https://fiverr-res.cloudinary.com/image/upload/v1721204922/listings_assets/gq_icons/fallback-check.svg';
